import { render, staticRenderFns } from "./platformBill.vue?vue&type=template&id=5973fc90"
import script from "./platformBill.vue?vue&type=script&lang=js"
export * from "./platformBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports